import { useTranslation } from "react-i18next";
import { Type, Languages, Hash, MapPin } from "lucide-react";
import { NeuButton } from "../../../components/neu/Neu";
import { Field } from "../../../components/neu/Field";
import { LocationPicker } from "../../map/LocationPicker";
import { GeoFields } from "./GeoFields";
import { BasicsHeader } from "./BasicsHeader";
import { CalendarSystemField } from "./CalendarSystemField";

export const BasicsTab = ({ form, set, onLocate, onPickLocation }) => {
  const { t } = useTranslation();

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <BasicsHeader form={form} set={set} />
      <Field label={t("branches.name")} testId="branch-name" value={form.name} onChange={(v) => set("name", v)} required accent="sky" icon={Type} autoLang="en" onAuto={(v) => set("name_ar", v)} />
      <Field label={t("branches.nameAr")} testId="branch-name_ar" value={form.name_ar} onChange={(v) => set("name_ar", v)} accent="violet" icon={Languages} autoLang="ar" onAuto={(v) => set("name", v)} />
      <div>
        <Field label={t("branches.code")} testId="branch-code" value={form.code || ""}
          onChange={(v) => set("code", v.toUpperCase().replace(/[^A-Z]/g, "").slice(0, 4))} accent="emerald" icon={Hash} />
        <p className="mt-1 text-xs text-muted-foreground">{t("branches.codeHint")}</p>
      </div>
      <div className="sm:col-span-2">
        <Field label={t("branches.address")} testId="branch-address" value={form.address} onChange={(v) => set("address", v)} accent="orange" icon={MapPin} />
      </div>
      <div className="sm:col-span-2">
        <p className="label-xs mb-2">{t("map.pickLocation")}</p>
        <LocationPicker latitude={form.latitude} longitude={form.longitude} radiusM={form.geofence_radius_m} onChange={onPickLocation} />
      </div>
      <GeoFields form={form} set={set} />
      <CalendarSystemField form={form} set={set} />
      <div className="sm:col-span-2 flex flex-wrap items-center gap-3">
        <NeuButton type="button" data-testid="branch-use-location" onClick={onLocate}>{t("branches.useMyLocation")}</NeuButton>
        <p className="text-xs text-muted-foreground" data-testid="branch-timezone-hint">
          {t("branches.timezoneAuto")}:{" "}
          <span className="font-mono font-bold text-foreground">
            {form.timezone_name || "—"} (UTC{form.tz_offset_minutes >= 0 ? "+" : ""}
            {(form.tz_offset_minutes / 60).toFixed(1)})
          </span>
        </p>
      </div>
    </div>
  );
};
